(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('OrganisationSwitchController',OrganisationSwitchController);

    OrganisationSwitchController.$inject = ['$uibModalInstance', 'entity', 'Organisation', 'Collectivity', 'Company', 'Principal'];

    function OrganisationSwitchController($uibModalInstance, entity, Organisation, Collectivity, Company, Principal) {
        var vm = this;
        vm.collectivitysNoResults = false;
        vm.getCollectivities = getCollectivities;
        vm.getCompanies = getCompanies;
        vm.organisation = entity;
        vm.clear = clear;
        vm.merge = merge;
        vm.collectivityTarget;
        vm.companyTarget;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function merge (id) {
            var targetId = vm.collectivityTarget? vm.collectivityTarget.id : vm.companyTarget? vm.companyTarget.id : null;
            if (!targetId) {
                return;
            }
            Organisation.merge({sourceId: id, targetId: targetId},
                function () {
                    $uibModalInstance.close(true);
                });
        }

        function getCollectivities(q) {
            return Collectivity.search({ query: q }).$promise.then(function (collectivities) {
                vm.collectivitysNoResults = collectivities.length === 0;

                if (isAdmin()) {
                    collectivities.map( function(org) {
                        if (org.equipeCommerciale) {
                            org.name = org.name + ' (' + org.equipeCommerciale.name+ ')'
                        }
                    });
                }

                return collectivities;
            });
        }

        function getCompanies(q) {
            return Company.search({ query: q }).$promise.then(function (companies) {
                if (isAdmin()) {
                    companies.map( function(org) {
                        if (org.equipeCommerciale) {
                            org.name = org.name + ' (' + org.equipeCommerciale.name+ ')'
                        }
                    });
                }
                vm.companiesNoResults = companies.length === 0;
                return companies;
            });
        }
    }
})();
